import React from 'react';
import { Typography } from '@material-ui/core';

const InformationTextControl = ({
  pointId,
  currentValue,
  symbol,
  label,
  config = {},
}) => {
  const baseStyle = {
    backgroundColor: '#FFFFFF1A',
    borderRadius: '6px',
    padding: '14px 16px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    opacity: 0.6,
  };

  const labelStyle = {
    color: '#FFFFFF',
    fontSize: '18px',
    fontWeight: 400,
  };

  const valueStyle = {
    color: '#FFFFFF99',
    fontSize: '18px',
    fontWeight: 800,
    textAlign: 'right',
    minWidth: '80px',
  };

  const formatValue = () => {
    const numValue = Number(currentValue);
    if (config?.customEnum?.[numValue]) {
      return config?.customEnum[numValue];
    }
    if (isNaN(numValue)) {
      return currentValue;
    }
    return Number.isInteger(numValue) ? String(numValue) : numValue.toFixed(1);
  };

  return (
    <div key={pointId} style={baseStyle}>
      <Typography style={labelStyle}>{label}</Typography>
      <Typography style={valueStyle}>
        {formatValue()} {symbol}
      </Typography>
    </div>
  );
};

export default InformationTextControl;
